import React, { useState, useEffect } from "react";
import Page from "components/Page";
import FullScreenLoader from "components/Loaders/FullScreenLoader";
import { getTop10ResultForExam } from "./firebase";
import MaterialTable from "material-table";

export default function AllResult({ match }) {
  let key = match.params.key;

  let [result, setResult] = useState(null);

  useEffect(() => {
    async function init() {
      let top10 = await getTop10ResultForExam(key);
      setResult(top10);
    }

    init();
  }, [key]);

  if (!result) return <FullScreenLoader />;
  return (
    <Page>
      <div
        style={{
          maxWidth: "600px",
          margin: "auto"
        }}
      >
        <MaterialTable
          title="Result"
          columns={[
            {
              title: "Rank",
              field: "rank",
              type: "numeric"
            },
            {
              title: "Name",
              field: "name"
            },
            {
              title: "Score",
              field: "score",
              type: "numeric"
            }
          ]}
          options={{
            sorting: true,
            search: true,
            pageSize: 20
          }}
          data={result}
        />
      </div>
    </Page>
  );
}
